import axios from 'axios';

const baseUrl = '/services/isnaportalsync/api/fno/nz007';

export const getNz007 = (params: string, tokenStr: string) => {
    return axios.get(baseUrl + params, {
        headers: { Authorization: `${tokenStr}` },
    });
};
